import { render, staticRenderFns } from "./AddMathFormula.vue?vue&type=template&id=46e28040"
import script from "./AddMathFormula.vue?vue&type=script&lang=js"
export * from "./AddMathFormula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports